import { CoercionType } from './CoercionType';
import { SetDataAdapterMethod } from './SetDataAdapterMethod';
import { SetDataArgs } from './SetDataArgs';
import { getAdapter } from '../../adapters/AdapterManager';
import MessageComposeAdapter from '../../adapters/MessageComposeAdapter';
import escapeStringForHtml from '../../utils/escapeStringForHtml';
import { ApiErrorCode } from '../ApiErrorCode';
import { ApiMethodCallback } from '../ApiMethod';
import { createErrorResult, createSuccessResult } from '../ApiMethodResponseCreator';
import trySanitizeHtml from '../body/trySanitizeHtml';
import { hasSelectionChanged, SelectedData } from '../selectedData/SelectedData';
import { Browser, getBrowserInfo } from 'owa-user-agent';

export const MAX_BODY_API_LENGTH = 1000000;

export default async function setDataAsyncApiMethodBase(
    hostItemIndex: string,
    controlId: string,
    args: SetDataArgs,
    callback: ApiMethodCallback,
    setData: SetDataAdapterMethod,
    getSelectedData?: () => SelectedData
) {
    const data = !!args.appendTxt ? args.appendTxt : args.data; // get AppendOnSend txt if it is there
    if (data.length > MAX_BODY_API_LENGTH) {
        callback(createErrorResult(ApiErrorCode.OoeInvalidDataFormat));
        return;
    }

    const selectedData = getSelectedData && getSelectedData();

    let result: string = null;
    if (args.coercionType === CoercionType.Html) {
        result = await trySanitizeHtml(data);
        if (result == null) {
            callback(createErrorResult(ApiErrorCode.HtmlSanitizationFailure));
            return;
        }
    } else {
        const adapter: MessageComposeAdapter = getAdapter(hostItemIndex) as MessageComposeAdapter;
        if (adapter.getBodyType() === 'HTML' && !args.appendOnSend) {
            // do not escape text for appendOnSend (will escape later)
            result = escapeStringForHtml(data);
        } else {
            result = data;
        }
    }
    if (!!args.appendOnSend) {
        args.appendOnSend.txt = result;
        setData(args.appendOnSend);
    } else {
        if (getSelectedData) {
            const latestSelectedData = getSelectedData();
            if (hasSelectionChanged(selectedData, latestSelectedData)) {
                callback(createErrorResult(ApiErrorCode.CursorPositionChanged));
                return;
            }
        }

        setData(result);
        if (getBrowserInfo().browser === Browser.FIREFOX) {
            (document.activeElement as HTMLElement).blur();
        }
    }

    callback(createSuccessResult());
}
